import React from 'react';
import { cn } from '@/lib/utils';

export interface TableScaffoldProps {
  /** Optional toolbar row: title, filters, actions */
  toolbar?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * Table chrome: compact toolbar + table surface. Console density.
 */
export const TableScaffold: React.FC<TableScaffoldProps> = ({
  toolbar,
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        'rounded-md border border-border bg-card overflow-hidden',
        className
      )}
    >
      {toolbar != null && (
        <div className="flex items-center justify-between gap-4 border-b border-border bg-muted/30 px-3 py-1.5">
          {toolbar}
        </div>
      )}
      <div className="overflow-x-auto">{children}</div>
    </div>
  );
};

export default TableScaffold;
